import { useState, Dispatch, SetStateAction } from 'react'

interface ILoadableDataState<T> {
    data?: T
    loading: boolean
}
export const useLoadableDataState = <T extends any>(
    initialState?: Partial<ILoadableDataState<T>>,
): [ILoadableDataState<T>, Dispatch<SetStateAction<Partial<ILoadableDataState<T>>>>] => {
    const [currState, setCurrState] = useState({
        loading: false,
        ...(initialState ?? {}),
    })

    const setState = (state: Partial<ILoadableDataState<T>>) => {
        setCurrState({
            ...(currState ?? {}),
            ...(state ?? {}),
        } as ILoadableDataState<T>)
    }

    return [currState, setState]
}
